import React from 'react'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import ContattaciTemplate from 'components/templates/ContattaciTemplate/ContattaciTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

const ContattiPage = ({ pagina }) => <ContattaciTemplate pagina={pagina} />

export const getStaticProps = NextWrapper.getStaticProps(async ({ locale }) => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'contatti' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina },
    revalidate: 60 * 2,
  }
}, '/contatti')

export default ContattiPage
